import * as Sentry from '@sentry/browser';
import { createRoot } from 'react-dom/client';

import App from './_app';
import config from './_shared/constants/config';
import './_shared/styles/style.css';

Sentry.init({
  dsn: config.sentryDSN,
  environment: config.environment,
});

// TODO: Test todo
const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
